import { render, staticRenderFns } from "./goodsPop.vue?vue&type=template&id=107fee20&scoped=true"
import script from "./goodsPop.vue?vue&type=script&lang=js"
export * from "./goodsPop.vue?vue&type=script&lang=js"
import style0 from "./goodsPop.vue?vue&type=style&index=0&id=107fee20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107fee20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107fee20')) {
      api.createRecord('107fee20', component.options)
    } else {
      api.reload('107fee20', component.options)
    }
    module.hot.accept("./goodsPop.vue?vue&type=template&id=107fee20&scoped=true", function () {
      api.rerender('107fee20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/goodsListActive/components/goodsPop.vue"
export default component.exports